import { FONT_CDN_URL } from '@pixum/fonts';

/**
 * Renders @font-face declarations as an inline <style> tag using the canonical
 * CDN URLs from @pixum/fonts. React 19 hoists <style href precedence> tags to
 * <head> and deduplicates them across concurrent renders.
 *
 * Using a component instead of hardcoded CSS keeps the URLs as a single source
 * of truth: updating @pixum/fonts automatically updates the font-face src here.
 */
export function FontFaces() {
  const css = `
@font-face {
  font-family: 'Bricolage Grotesque';
  src: url('${FONT_CDN_URL.HEADING.SEMI_BOLD}') format('woff2');
  font-weight: 600;
  font-display: optional;
}

@font-face {
  font-family: 'Bricolage Grotesque';
  src: url('${FONT_CDN_URL.HEADING.EXTRA_BOLD}') format('woff2');
  font-weight: 800;
  font-display: optional;
}

@font-face {
  font-family: 'Inter';
  src: url('${FONT_CDN_URL.BODY.REGULAR}') format('woff2');
  font-weight: 400;
  font-display: optional;
}

@font-face {
  font-family: 'Inter';
  src: url('${FONT_CDN_URL.BODY.MEDIUM}') format('woff2');
  font-weight: 500;
  font-display: optional;
}

@font-face {
  font-family: 'Inter';
  src: url('${FONT_CDN_URL.BODY.SEMI_BOLD}') format('woff2');
  font-weight: 600;
  font-display: optional;
}

@font-face {
  font-family: 'Inter';
  src: url('${FONT_CDN_URL.BODY.BOLD}') format('woff2');
  font-weight: 700;
  font-display: optional;
}
`.trim();

  // href acts as a deduplication key — React 19 ensures this style block is
  // only inserted once even if FontFaces renders in multiple concurrent trees.
  return (
    <style href="pixum-font-faces" precedence="default">
      {css}
    </style>
  );
}
